// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"fcaa5c11","457":"2a82c65b","866":"58b0d47c","982":"9c8d0f04","993":"3def336a"}[chunkId] + ".chunk.js";
};